import { makePrivateApiCall } from "utilities/dist/api";
import { trackDownloadCustomerBalancePdfEvent } from "../../common/analytics";
import { isIos } from "api/src/common/helpers";
import { toast } from "react-semantic-toasts";
import downloadFile from "js-file-download";

export const loadCustomerAutoFillSuggestions = query => {
    return makePrivateApiCall({
        url: "/customer/auto-fill-suggestions",
        params: { query },
    });
};

const loadedExpirations = [];
export const loadCustomerExpiration = customerId => {
    if (loadedExpirations[customerId] !== undefined) {
        return Promise.resolve(loadedExpirations[customerId]);
    }

    return makePrivateApiCall({
        url: `/customer/${customerId}/tabc-expiration`,
    }).then(res => {
        loadedExpirations[customerId] = res.data;
        return res.data;
    });
};

export const validateCustomerPermitCode = customerId => {
    return makePrivateApiCall({
        url: `/customer/${customerId}/permit-data`,
    }).then(res => {
        return res.data;
    });
};

export const validateCustomerDelinquency = customerId => {
    return makePrivateApiCall({
        url: `/customer/${customerId}/delinquency`,
    }).then(res => {
        return res.data;
    });
};

export const loadCustomerBalance = customerId => {
    return makePrivateApiCall({
        url: `/customer/${customerId}/check-balance`,
    }).then(res => {
        return res.data;
    });
};

/**
 * @function generateBalancePdf
 *
 * @param {String} customerId id of the customer
 * @param {Function} setGeneratingPdfUrl Function that will be called to set the sate of generation process, true will be passed when the process starts and false will be passed when the process ends un/successfully
 * @param {Boolean} shouldDownload if the pdf should be immediately downloaded
 */
export const generateBalancePdf = (customerId, setGeneratingPdfUrl, shouldDownload = true) => {
    trackDownloadCustomerBalancePdfEvent(customerId, {});
    setGeneratingPdfUrl(true);

    return makePrivateApiCall({
        method: "POST",
        url: `/customer/${customerId}/balance/pdf`,
        // only when download is needed, we need the file as blob, otherwise json /default is fine
        ...(shouldDownload ? { responseType: "blob" } : {}),
    })
        .then(res => {
            trackDownloadCustomerBalancePdfEvent(customerId, { success: true });
            setGeneratingPdfUrl(false);
            if (shouldDownload) {
                if (isIos()) {
                    const file = new Blob([res.data], { type: "application/pdf" });
                    const fileURL = URL.createObjectURL(file);
                    return window.open(fileURL, "_blank");
                }
                return downloadFile(res.data, `customer_balance_${customerId}_${Date.now()}.pdf`);
            }
            // when not downloading, data will contain url
            return res.data?.url;
        })
        .catch(err => {
            trackDownloadCustomerBalancePdfEvent(customerId, { error: true });
            setGeneratingPdfUrl(false);
            toast({
                icon: "file",
                type: "error",
                title: "Error generating pdf",
                description: `${err.message}`,
            });
        });
};
